import { render, staticRenderFns } from "./breed_formula_sel.vue?vue&type=template&id=2c79b5bb&scoped=true"
import script from "./breed_formula_sel.vue?vue&type=script&lang=js"
export * from "./breed_formula_sel.vue?vue&type=script&lang=js"
import style0 from "./breed_formula_sel.vue?vue&type=style&index=0&id=2c79b5bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c79b5bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c79b5bb')) {
      api.createRecord('2c79b5bb', component.options)
    } else {
      api.reload('2c79b5bb', component.options)
    }
    module.hot.accept("./breed_formula_sel.vue?vue&type=template&id=2c79b5bb&scoped=true", function () {
      api.rerender('2c79b5bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/breed_formula_sel.vue"
export default component.exports